$( document ).ready( function() {

	/* - - - - - - - - - - - - - -       scroll to       - - - - - - - - - - - - - - - */
	if ( $( '.main-page' ).length ) {
		$( window ).on( 'hashchange', function() {
			window.location.reload();
		});
	}
	const hashTpl = '#scroll-';
	let hash = window.location.hash;
	if ( hash && hash.match( RegExp( '^' + hashTpl, 'gi' ) ) !== null ) {
		hash = '#' + hash.substring( hashTpl.length );
		let count = 1;
		if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
			count = 2;
		}
		for ( let i = 0; i < count; i++ ) {
			setTimeout( function () {
				let addTop = 0;
				if ( parseInt( $( hash ).css( 'padding-top' ) ) === 0 ) {
					addTop = $( '.header' ).innerHeight();
				} else {
					if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
						addTop = $( '.header' ).innerHeight();
					}
				}
				let posTop = $( hash ).offset().top - addTop;
				$( 'html, body' ).stop().animate({ scrollTop: posTop + 'px' }, 500, 'linear' );
			}, i * 400 + 100 );
		}
	}

	setTimeout( function() {
		AOS.init({
			duration: 1000,
			offset: 80,
			once: true
		});
		$( '.section-group, .main-bg' ).css( 'opacity', 1 );
	}, 500 );

	gsap.registerPlugin( ScrollTrigger );
	setTimeout( function() {
		ScrollTrigger.refresh();
	}, 100 );

	/* - - - - - - - - - - - - - -       init select2       - - - - - - - - - - - - - - - */
	$( '.js-select' ).select2({
		width: '100%',
		minimumResultsForSearch: -1
	}).on( 'select2:select', function( e ) {
		// if ( e.params.data.text === '' ) {
		// 	$( e.target ).removeClass( 'filled' );
		// } else {
		// 	$( e.target ).addClass( 'filled' );
		// }
	});

	// $( 'input:not(.btn):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="reset"]), textarea' ).on( 'input', function() {
	// 	const $this = $( this );
	// 	const $parent = $this.closest( '.form-group' );
	// 	let isRequired = $this.attr( 'required' ) !== undefined ? true : false;
	// 	if ( isRequired ) {
	// 		validateField( $parent, $this.val() );
	// 	}
	// });

	/* - - - - - - - - - - - - - -       validate fields       - - - - - - - - - - - - - - - */
	function validateField( $parent, val ) {
		if ( val.length > 2 ) {
			$parent.removeClass( 'has-error' ).addClass( 'has-success' );
		} else {
			$parent.removeClass( 'has-success' ).addClass( 'has-error' );
		}
	}

	/* - - - - - - - - - - - - - -       rebuild header       - - - - - - - - - - - - - - - */
	function rebuildHeader() {
		const $button = $( '.header-button' ).detach();
		const $lang = $( '.lang' ).detach();
		if ( window.matchMedia( '(max-width: 1199px)' ).matches ) {
			$( '.header-modal' ).append( $lang );
			$( '.header-modal' ).append( $button );
		} else {
			$( '.header-right' ).prepend( $button );
			$( '.header-right' ).prepend( $lang );
		}
	}
	rebuildHeader();
	$( window ).on( 'resize', function() {
		rebuildHeader();
	});

	/* - - - - - - - - - - - - - -       fixed header       - - - - - - - - - - - - - - - */
	function fixedHeader() {
		const top = $( window ).scrollTop();
		if ( top > 0 ) {
			$( '.header' ).addClass( 'fixed' );
		} else {
			$( '.header' ).removeClass( 'fixed' );
		}
	}
	fixedHeader();
	$( window ).on( 'scroll', function() {
		fixedHeader();
	});
	setTimeout( function() {
		$( '.header' ).css( 'transform', 'none' );
	}, 1000 );

	/* - - - - - - - - - - - - - -       menu toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.menu-toggle', function() {
		const $this = $( this );
		if ( !$this.hasClass( 'active' ) ) {
			$this.addClass( 'active' );
			$( '.header-modal' ).addClass( 'show' );
		} else {
			$this.removeClass( 'active' );
			$( '.header-modal' ).removeClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       submenu toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.top-menu .icon, .top-menu li span:not(.icon)', function() {
		if ( window.matchMedia( '(max-width: 1199px)' ).matches ) {
			const $parent = $( this ).closest( 'li' );
			if ( !$parent.hasClass( 'show' ) ) {
				$parent.addClass( 'show' );
				$parent.find( 'ul' ).slideDown( 300 );
			} else {
				$parent.removeClass( 'show' );
				$parent.find( 'ul' ).slideUp( 300 );
			}
		}
	});
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 1200px)' ).matches ) {
			$( '.top-menu li' ).removeClass( 'show' );
			$( '.top-menu ul' ).css( 'display', '' );
		}
	});

	/* - - - - - - - - - - - - - -       lang toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.lang-title', function() {
		if ( window.matchMedia( '(max-width: 1199px)' ).matches ) {
			const $parent = $( this ).closest( '.lang' );
			if ( !$parent.hasClass( 'show' ) ) {
				$parent.addClass( 'show' );
			} else {
				$parent.removeClass( 'show' );
			}
			$( document ).click( function( e ) {
				if ( $( e.target ).closest( '.lang' ).length ) {
					return;
				}
				$( '.lang' ).removeClass( 'show' );
			});
		}
	});
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 1200px)' ).matches ) {
			$( '.lang' ).removeClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       modal show       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-modal', function( e ) {
		e.preventDefault();
		$( '.header-modal' ).removeClass( 'show' );
		$( '.menu-toggle' ).removeClass( 'active' );
		$( '.modal' ).removeClass( 'show' );
		const $this = $( this ),
			$modal = $( $this.attr( 'href' ) );
		if ( $modal.length ) {
			$modal.addClass( 'show' );
		}
	});
	$( document ).on( 'click', '.modal-close', function() {
		$( '.modal' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       chart animation       - - - - - - - - - - - - - - - */
	function animationChart() {
		$( '.first-card__box-chart svg' ).each( function() {
			const $svg = $( this );
			$svg.find( '.line mask path' ).each( function() {
				const $line = $( this );
				const distance = Math.ceil( $line[ 0 ].getTotalLength() );
				$line.css({
					'stroke-dasharray': distance + '',
					'stroke-dashoffset': distance + ''
				});
				setTimeout( function() {
					$line.animate({ 'stroke-dashoffset': 0 }, 1500 );
				}, 2000 );
			});
		});
	}
	if ( $( '.first-card__box-chart svg' ).length ) {
		animationChart();
	}

	/* - - - - - - - - - - - - - -       first card sign up toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-first-card-modal', function( e ) {
		e.preventDefault();
		if ( window.matchMedia( '(max-width: 1199px)' ).matches ) {
			const $parent = $( this ).closest( '.first-card__box-button' );
			$parent.toggleClass( 'show' );
		}
	});
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 1200px)' ).matches ) {
			$( '.first-card__box-button' ).toggleClass( 'show' );
		}
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.first-card__box-button' ).length ) {
			return;
		}
		$( '.first-card__box-button' ).removeClass( 'show' );
	});

	/* - - - - - - - - - - - - - -       rebuild partners       - - - - - - - - - - - - - - - */
	function rebuildPartners() {
		$( '.partners-box' ).each( function() {
			const $this = $( this ),
				$parent = $this.closest( '.partners-group' ),
				$partnersBox = $this.detach();
			if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
				$parent.find( '.partners-tabs__box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).after( $partnersBox );
			} else {
				$parent.find( '.partners-content' ).append( $partnersBox );
			}

			const $partnersInfo = $this.find( '.partners-box__info' ).detach();
			if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
				$this.find( '.partners-box__desc' ).after( $partnersInfo );
			} else {
				$this.find( '.partners-box__head' ).prepend( $partnersInfo );
			}
		});
	}
	if ( $( '.partners-box' ).length ) {
		rebuildPartners();
		$( window ).on( 'resize', function() {
			rebuildPartners();
		});
	}

	/* - - - - - - - - - - - - - -       set position progress step       - - - - - - - - - - - - - - - */
	function setPositionProgressStep() {
		$( '.partners-box__progress' ).each( function() {
			const $progress = $( this ),
				count = $progress.find( '.partners-box__progress-step' ).length;
			$progress.find( '.partners-box__progress-step' ).each( function() {
				const $progressStep = $( this ),
					index = $progressStep.index();
				if ( count % 2 ) {
					if ( index < Math.floor( count / 2 ) ) {
						$progressStep.addClass( 'step-left' );
					} else if ( index > Math.floor( count / 2 ) ) {
						$progressStep.addClass( 'step-right' );
					} else {
						$progressStep.addClass( 'step-center' );
					}
				} else {
					if ( index < count / 2 ) {
						$progressStep.addClass( 'step-left' );
					} else if ( index > count / 2 ) {
						$progressStep.addClass( 'step-right' );
					}
				}
			});
		});
	}
	if ( $( '.partners-box__progress' ).length ) {
		setPositionProgressStep();
	}

	/* - - - - - - - - - - - - - -       set parents progress       - - - - - - - - - - - - - - - */
	function setParentsProgress() {
		$( '.partners-box__progress-tip' ).each( function() {
			const $this = $( this ),
				$parent = $this.closest( '.partners-box__progress' ),
				step = $this.attr( 'data-step' ),
				$currentStep = $parent.find( '.partners-box__progress-step[data-step="' + step + '"]' ),
				index = $currentStep.index();
			if ( $parent.innerWidth() > 0 ) {
				let posLeft = $currentStep.position().left + $currentStep.innerWidth() / 2,
					displacement = ( $currentStep.innerWidth() - 35 ) / 2;
				if ( $currentStep.hasClass( 'step-left' ) ) {
					posLeft = posLeft - displacement;
				}
				if ( $currentStep.hasClass( 'step-right' ) ) {
					posLeft = posLeft + displacement;
				}
				setTimeout( function() {
					$this.css( 'left', posLeft + 'px' );
					$parent.find( '.partners-box__progress-step' ).removeClass( 'active current' );
					$parent.find( '.partners-box__progress-step' ).each( function() {
						if ( $( this ).index() < index ) {
							$( this ).addClass( 'active' );
						}
						if ( $( this ).index() === index ) {
							$( this ).addClass( 'current' );
						}
					});
				}, 100 );
			} else {
				$( '.partners-box__progress-step' ).removeClass( 'active current' );
				$this.css( 'left', 35 / 2 + 'px' );
			}
		});
	}
	if ( $( '.partners-box__progress' ).length ) {
		if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
			setTimeout( setParentsProgress, 400 );
		} else {
			setParentsProgress();
		}
		$( window ).on( 'resize', function() {
			if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
				setTimeout( setParentsProgress, 100 );
			} else {
				setParentsProgress();
			}
		});
	}

	$( document ).on( 'click', '.partners-box__progress-point', function() {
		const $this = $( this ),
			$progresStep = $this.closest( '.partners-box__progress-step' ),
			$progresBar = $this.closest( '.partners-box__progress' ),
			$progresTip = $progresBar.find( '.partners-box__progress-tip' );
		$progresTip.attr( 'data-step', $progresStep.attr( 'data-step' ) );
		setParentsProgress( 100 );
		setTimeout( function() {
			$progresTip.text( $progresStep.attr( 'data-percent' ) );
		}, 300 );
	});

	/* - - - - - - - - - - - - - -       parents tabs       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.partners-tabs__box', function() {
		const $this = $( this ),
			$parent = $this.closest( '.partners-tabs' );
		if ( !$this.hasClass( 'active' ) ) {
			$parent.find( '.partners-tabs__box' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$( '.partners-box' ).removeClass( 'show' );
			$( '.partners-box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).addClass( 'show' );
			$( '.partners-box__title, .partners-box__text' ).css({
				'opacity': '',
				'transform': ''
			});
			setTimeout( function() {
				$( '.partners-box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).find( '.partners-box__title' ).css({
					'opacity': 1,
					'transform': 'translateY(0)'
				});
			}, 100 );
			setTimeout( function() {
				$( '.partners-box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).find( '.partners-box__text' ).css({
					'opacity': 0.7,
					'transform': 'translateY(0)'
				});
			}, 200 );
			if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
				$( '.partners-box' ).slideUp( 500 );
				$( '.partners-box[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).slideDown( 500 );
				setTimeout( setParentsProgress, 600 );
				setTimeout( function() {
					ScrollTrigger.refresh();
				}, 500 );
			} else {
				setParentsProgress();
			}
		}
	});
	function shopPartnersMobile() {
		if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
			$( '.partners-box' ).each( function() {
				const $this = $( this );
				if ( $this.hasClass( 'show' ) && $this.css( 'display' ) === 'none' ) {
					$this.slideDown( 300 );
					setTimeout( function(  ) {
						ScrollTrigger.refresh();
					}, 300 );
				}
			});
		}
	}
	if ( $( '.partners-box' ).length ) {
		setTimeout( function() {
			$( '.partners-box.show .partners-box__title' ).css({
				'opacity': 1,
				'transform': 'translateY(0)'
			});
		}, 100 );
		setTimeout( function() {
			$( '.partners-box.show .partners-box__text' ).css({
				'opacity': 0.7,
				'transform': 'translateY(0)'
			});
		}, 200 );
		shopPartnersMobile();
		$( window ).on( 'resize', function() {
			shopPartnersMobile();
		});
	}
	$( window ).on( 'resize', function() {
		if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
			$( '.partners-box' ).css( 'display', '' );
		}
	});

	/* - - - - - - - - - - - - - -       init advantages slider       - - - - - - - - - - - - - - - */
	const sliderAdvantage = $( '.js-advantages-slider' );
	let advantageCountSlide = 0,
		advantageShowSlide = 0;
	sliderAdvantage.on( 'refreshed.owl.carousel', function( e ) {
		advantageCountSlide = e.item.count;
		advantageShowSlide = e.page.size;
	});
	sliderAdvantage.owlCarousel({
		loop: false,
		nav: true,
		dots: false,
		smartSpeed: 600,
		items: 1,
		slideBy: 1,
		margin: 0,
		responsive: {
			680: {
				items: 2
			},
			1200: {
				items: 3
			}
		}
	});

	function setAdvantagesScroll() {
		const advantagesArrowTpl = '<div class="advantages-slider__arrows">' +
				'<div class="advantages-slider__prev"></div>' +
				'<div class="advantages-slider__next"></div>' +
			'</div>';
		$( '.js-advantages-slider-scroll' ).before( advantagesArrowTpl );

		const $advantagesScroll = $( '.js-advantages-slider-scroll' ),
			$advantagesBox = $advantagesScroll.find( '.advantages-box:nth-child(1)' ),
			$arrowPrev = $( '.advantages-slider__prev' ),
			$arrowNext = $( '.advantages-slider__next' ),
			count = $advantagesScroll.find( '.advantages-box' ).length;
		let posLeft = $advantagesBox.scrollLeft();
		if ( posLeft === 0 ) {
			$arrowPrev.addClass( 'disabled' );
		}
		$arrowPrev.on( 'click', function() {
			const step = $advantagesBox.innerWidth() + parseInt( $advantagesBox.css( 'margin-right' ) ) / 2;
			posLeft -= step;
			$advantagesScroll.stop().animate({ scrollLeft: posLeft + 'px' }, 500 );
		});
		$arrowNext.on( 'click', function() {
			const step = $advantagesBox.innerWidth() + parseInt( $advantagesBox.css( 'margin-right' ) ) / 2;
			posLeft += step;
			$advantagesScroll.stop().animate({ scrollLeft: posLeft + 'px' }, 500 );
		});
		$advantagesScroll.on( 'scroll', function() {
			const scrollWidth = $advantagesScroll.innerWidth(),
				maxScrollWidth = count * $advantagesBox.innerWidth() + ( count - 1 ) * parseInt( $advantagesBox.css( 'margin-right' ) );
			let scrollLeft = $advantagesScroll.scrollLeft();
			posLeft = scrollLeft;
			if ( scrollLeft <= 0 ) {
				posLeft = 0;
				$arrowPrev.addClass( 'disabled' );
			} else {
				$arrowPrev.removeClass( 'disabled' );
			}
			if ( maxScrollWidth <= scrollWidth + scrollLeft - 48 ) {
				posLeft = maxScrollWidth - scrollWidth + 48;
				$arrowNext.addClass( 'disabled' );
			} else {
				$arrowNext.removeClass( 'disabled' );
			}
		});
		$( window ).on( 'resize', function() {
			const scrollWidth = $advantagesScroll.innerWidth(),
				maxScrollWidth = count * $advantagesBox.innerWidth() + ( count - 1 ) * parseInt( $advantagesBox.css( 'margin-right' ) ),
				scrollLeft = $advantagesScroll.scrollLeft();
			if ( maxScrollWidth < scrollWidth + scrollLeft - 48 ) {
				$arrowNext.addClass( 'disabled' );
			} else {
				$arrowNext.removeClass( 'disabled' );
			}
		});
	}
	if ( $( '.js-advantages-slider-scroll' ).length ) {
		setAdvantagesScroll();
	}

	/* - - - - - - - - - - - - - -       rebuild reviews       - - - - - - - - - - - - - - - */
	function rebuildReviews() {
		const $reviewsArrows = $( '.reviews-arrows' ).detach();
		if ( window.matchMedia( '(min-width: 768px)' ).matches ) {
			$( '.reviews-content' ).append( $reviewsArrows );
		} else {
			$( '.reviews-inner' ).append( $reviewsArrows );
		}
	}
	if ( $( '.reviews-content' ).length ) {
		rebuildReviews();
		$( window ).on( 'resize', function() {
			rebuildReviews();
		});
	}

	/* - - - - - - - - - - - - - -       init reviews slider       - - - - - - - - - - - - - - - */
	const $sliderReviews = $( '.js-reviews-slider' );
	if ( $sliderReviews.length ) {
		let $sliderReviewsCounter;

		const updateSliderReviewsCounter = function( slick ) {
			let currentSlide = slick.slickCurrentSlide() + 1,
				slideCount = slick.slideCount;
			if ( currentSlide < 10 ) {
				currentSlide = '0' + currentSlide;
			}
			if ( slideCount < 10 ) {
				slideCount = '0' + slideCount;
			}
			$sliderReviewsCounter.html( '<b>' + currentSlide + '</b> / ' + slideCount );
		};

		$sliderReviews.on( 'init', function( event, slick ) {
			$sliderReviews.append( '<div class="reviews-counter" />'  );
			$sliderReviewsCounter = $sliderReviews.find( '.reviews-counter' );
			updateSliderReviewsCounter( slick );
		});
		$sliderReviews.on( 'afterChange', function( event, slick, currentSlide ) {
			updateSliderReviewsCounter( slick, currentSlide );
		});
	}
	$sliderReviews.slick({
		infinite: false,
		arrows: true,
		dots: false,
		fade: true,
		speed: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipeToSlide: true,
		appendArrows: $( '.reviews-arrows' )
	});

	/* - - - - - - - - - - - - - -       faq tabs       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.faq-tabs li', function() {
		const $this = $( this ),
			$parent = $( this ).closest( '.faq-tabs' );
		if ( !$this.hasClass( 'active' ) ) {
			$parent.find( 'li' ).removeClass( 'active' );
			$this.addClass( 'active' );
			$( '.faq-list' ).removeClass( 'show' );
			$( '.faq-list[data-tab="' + $this.attr( 'data-tab' ) + '"]' ).addClass( 'show' );
		}
	});

	/* - - - - - - - - - - - - - -       faq toggle       - - - - - - - - - - - - - - - */
	$( '.faq-list__box' ).each( function() {
		if ( $( this ).hasClass( 'active' ) ) {
			$( this ).find( '.faq-list__box-body' ).slideDown( 300 );
		}
	});
	$( document ).on( 'click', '.js-faq', function() {
		const $this = $( this ),
			$parent = $this.closest( '.faq-list__box' );
		if ( !$parent.hasClass( 'active' ) ) {
			$( '.faq-list__box' ).removeClass( 'active' );
			$parent.addClass( 'active' );
			$( '.faq-list__box-body' ).slideUp( 300 );
			$parent.find( '.faq-list__box-body' ).slideDown( 300 );
		} else {
			$parent.removeClass( 'active' );
			$parent.find( '.faq-list__box-body' ).slideUp( 300 );
		}
	});

	/* - - - - - - - - - - - - - -       about toggle       - - - - - - - - - - - - - - - */
	let aboutHeight;
	function setAboutHeight() {
		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
			aboutHeight = 0;
		} else {
			aboutHeight = 142;
		}
		return aboutHeight;
	}
	$( '.about-tabs__box' ).each( function() {
		const $this = $( this ),
			$text = $this.find( '.about-tabs__box-text' ),
			currentHeight = $text.innerHeight();
		$text.attr( 'data-height', currentHeight );
		$text.height( 0 );
		setAboutHeight();
		if ( $this.hasClass( 'active' ) ) {
			if ( currentHeight < aboutHeight ) {
				$this.find( '.about-tabs__box-text' ).height( aboutHeight );
			} else {
				$this.find( '.about-tabs__box-text' ).height( currentHeight );
			}
		}
	});
	$( document ).on( 'click', '.js-about-tabs', function() {
		const $this = $( this ),
			$parent = $this.closest( '.about-tabs__box' ),
			currentHeight = parseFloat( $parent.find( '.about-tabs__box-text' ).attr( 'data-height' ) );
		setAboutHeight();
		if ( !$parent.hasClass( 'active' ) ) {
			$( '.about-tabs__box' ).removeClass( 'active' );
			$parent.addClass( 'active' );
			$( '.about-tabs__box-text' ).height( 0 );
			if ( currentHeight < aboutHeight ) {
				$parent.find( '.about-tabs__box-text' ).height( aboutHeight );
			} else {
				$parent.find( '.about-tabs__box-text' ).height( currentHeight );
			}
		} else {
			$parent.removeClass( 'active' );
			$parent.find( '.about-tabs__box-text' ).height( 0 );
		}
		setTimeout( function() {
			ScrollTrigger.refresh();
		}, 500 );
	});
	if ( $( '.about-tabs__box.active' ).length ) {
		$( window ).on( 'resize', function() {
			if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
				$( '.about-tabs__box.active .about-tabs__box-text' ).css( 'height', '' );
			}
		});
	}

	/* - - - - - - - - - - - - - -       init trust slider       - - - - - - - - - - - - - - - */
	const sliderTrust = $( '.js-trust-slider' );
	let trustCountSlide = 0,
		trustShowSlide = 0;
	sliderTrust.on( 'refreshed.owl.carousel', function( e ) {
		trustCountSlide = e.item.count;
		trustShowSlide = e.page.size;
	});
	sliderTrust.owlCarousel({
		loop: true,
		nav: false,
		dots: false,
		mouseDrag: false,
		touchDrag: false,
		items: 1,
		slideBy: 1,
		smartSpeed: 0,
		margin: 0
	});
	function fixedTrust() {
		const height = trustCountSlide * $( '.trust-slider' ).innerHeight();
		ScrollTrigger.create({
			trigger: '.trust',
			start: 'top 130px',
			end: 'top+=' + height + 'px 130px',
			ease: 'power0.easeNone',
			scrub: true,
			pin: true,
			invalidateOnRefresh: true,
			onUpdate: ({ progress, direction, isActive }) => {
				const percentage = Math.floor( progress * ( trustCountSlide - trustShowSlide ) );
				sliderTrust.trigger( 'to.owl.carousel', [ percentage, 500, true ] );
			}
		});
	}
	if ( $( '.trust' ).length ) {
		fixedTrust();
	}

	/* - - - - - - - - - - - - - -       rebuild revenue       - - - - - - - - - - - - - - - */
	function rebuildRevenue() {
		const $button = $( '.revenue-box__button' ).detach();
		if ( window.matchMedia( '(max-width: 991px)' ).matches ) {
			$( '.revenue-box' ).append( $button );
		} else {
			$( '.revenue-box__head' ).append( $button );
		}
	}
	rebuildRevenue();
	$( window ).on( 'resize', function() {
		rebuildRevenue();
	});

	/* - - - - - - - - - - - - - -       article share toggle       - - - - - - - - - - - - - - - */
	$( document ).on( 'click', '.js-article-share', function() {
		const $parent = $( this ).closest( '.article-share__list' );
		$parent.toggleClass( 'show' );
	});
	$( document ).click( function( e ) {
		if ( $( e.target ).closest( '.article-share__list' ).length ) {
			return;
		}
		$( '.article-share__list' ).removeClass( 'show' );
	});

	function scrollAffiliates( direction ) {
		const $list = $( '.affiliates-table__body' );
		const $buttonPrev = $( '.affiliates-button__prev' );
		const $buttonNext = $( '.affiliates-button__next' );
		const count = 6;
		const allCount = $list.find( '.affiliates-table__row' ).length;
		const gap = parseInt( $list.css( 'gap' ) );
		const minHeight = $list.find( '.affiliates-table__row:first-child' ).innerHeight();
		const listHeight = $list.innerHeight();
		const scrollHeight = minHeight * count + gap * count;
		const scrollMax = minHeight * allCount + gap * ( allCount - 1 );
		const scrollStart = $list.scrollTop();
		let scrollEnd = 0;
		if ( direction === 'up' ) {
			scrollEnd = scrollStart - scrollHeight;
			if ( scrollEnd <= 0 ) {
				$buttonPrev.addClass( 'disabled' );
			}
			if ( listHeight + scrollEnd < scrollMax ) {
				$buttonNext.removeClass( 'disabled' );
			}
		}
		if ( direction === 'down' ) {
			scrollEnd = scrollStart + scrollHeight;
			if ( scrollStart === 0 && scrollMax > listHeight ) {
				$buttonPrev.removeClass( 'disabled' );
			}
			if ( listHeight + scrollEnd >= scrollMax ) {
				$buttonNext.addClass( 'disabled' );
			}
		}
		$list.animate({ scrollTop: scrollEnd }, 500 );
	}
	$( document ).on( 'click', '.js-affiliates-prev', function() {
		scrollAffiliates( 'up' );
	});
	$( document ).on( 'click', '.js-affiliates-next', function() {
		scrollAffiliates( 'down' );
	});
});
